import { render, staticRenderFns } from "./ModalSelecionarCamadas.vue?vue&type=template&id=478b912a&scoped=true&lang=pug"
import script from "./ModalSelecionarCamadas.vue?vue&type=script&lang=js"
export * from "./ModalSelecionarCamadas.vue?vue&type=script&lang=js"
import style0 from "./ModalSelecionarCamadas.vue?vue&type=style&index=0&id=478b912a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478b912a",
  null
  
)

export default component.exports